import { render, staticRenderFns } from "./SkeletonBuilder.vue?vue&type=template&id=6e89bce9&"
import script from "./SkeletonBuilder.vue?vue&type=script&lang=js&"
export * from "./SkeletonBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports